import { reactMount } from '@/lib/reactMount'
// import { useRef } from 'react'
import { Button } from '@/components/Button'
import { StarIcon, ArrowRight } from '@/components/Icons'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

export const testimonialsBlock = ({ dataset, umbraco }) => {
  /*
    TEMP: Mock data while Umbraco integration is pending

    To re-enable Umbraco data:
      1) Un-comment the 3 lines below
      2) Remove the mockData block

    // const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
    // umbraco ||= umbracoRef.current
    // const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'
  */

  const mockData = {
    anchorTarget: 'customer-reviews',
    title: 'Customer reviews',
    description:
      'Real feedback from customers who financed with UDC through our dealer network.',
    ctaUrl: 'https://www.google.com/search?q=udc+finance&sca_esv=4db0d55285a79519&rlz=1C1GCEA_enNZ1162NZ1162&sxsrf=AE3TifO9jwGciI6gQ-lcRm1uGlYiMx97BA%3A1755142348848&ei=zFidaP3HM-SI4-EP9KDooAc&ved=0ahUKEwj93e7hromPAxVkxDgGHXQQGnQQ4dUDCBA&uact=5&oq=udc+finance&gs_lp=Egxnd3Mtd2l6LXNlcnAiC3VkYyBmaW5hbmNlMgQQIxgnMhMQLhiABBixAxgUGMcBGIcCGK8BMgsQABiABBiRAhiKBTIKEAAYgAQYQxiKBTIKEAAYgAQYFBiHAjIKEAAYgAQYQxiKBTILEC4YgAQY0QMYxwEyBRAAGIAEMgUQABiABDIFEAAYgARIzQhQoQRY3wZwAXgBkAEAmAHsAaABtwOqAQMyLTK4AQPIAQD4AQGYAgOgAscDwgIKEAAYsAMY1gQYR8ICEBAuGIAEGEMYxwEYigUYrwHCAhEQLhiABBiRAhjRAxjHARiKBZgDAIgGAZAGCJIHBTEuMC4yoAfTF7IHAzItMrgHxAPCBwUwLjEuMsgHDg&sclient=gws-wiz-serp#lrd=0x6d0d4875c79068e5:0x62cb7000bd35e21e,1,,,,',
    ctaText: 'View all reviews',
    styles: {
      backgroundColor: '#ffffff'
    },
    reviews: [
      {
        name: 'S Han',
        rating: 5,
        timeAgo: '4 weeks ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/AKlR1wScGQtXBhXqi',
        text:
          'I’m truly grateful to Benjamin for all his help throughout my loan application. He made the whole process smooth quick, and completely stress-free. Benjamin is highly professional and always responded to my emails or calls promptly, patiently answering all my questions. He even arranged a face-to-face passport verification at the fastest possible time, which really impressed me. Thanks to his support, I felt very confident and well taken care of during the entire process. I would highly recommend Benjamin to anyone looking for a reliable and professional loan manager.'
      },
      {
        name: 'S Doraisamy',
        rating: 5,
        timeAgo: '4 days ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/3lN6xx2dw97QpsadQ',
        text:
          'Thank you Iva for processing my finance loan. You were very efficient and responded fast to all the documents required with quick approval when everything was submitted. You gave constant updates on the status of finance application. It was stress free. I would recommend her to others.'
      },
      {
        name: 'M Simpson',
        rating: 5,
        timeAgo: '5 days ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/xwdI9ft4IKuP8c9kh',
        text:
          'Gabrielle was awesome. The process was quick, easy with great communication. The application done over the phone, documents were completed from my mobile and I was able to purchase the car as a cash buyer... '
      },
      {
        name: 'M Harris',
        rating: 5,
        timeAgo: '1 month ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/sVTKhBWEuHTvPFNxk',
        text:
          'Great service, made the process simple and understandable. Also, got things to happen a lot faster then I thought they would. Vivek communicated well and kept me updated throughout the process. Would happily use UDC again'
      },
      {
        name: 'G Hughes',
        rating: 5,
        timeAgo: '3 months ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/VsV8viAH0gEMQrvV5',
        text:
          'Emily provided excellent service with the financing of my vehicle, she went above and beyond my expectations and made me feel valued and respected as a customer. She was always polite and professional and ensured to secure the best deal for me in a timely manner. I will finance any future vehicles through UDC ... Especially through Emily 😊'
      },
      {
        name: 'Netana',
        rating: 5,
        timeAgo: '1 months ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/krD65wA5wkV4zefnI',
        text:
          'I had an aImazing experience with Benjamin at UDC Finance. From start to finish he made the whole loan process simple, stress-free, and easy to understand. He was professional, supportive, and always kept me updated. Couldn’t have asked for better service, highly recommend!'
      },
      {
        name: 'A S',
        rating: 5,
        timeAgo: '10 days ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/5ALImKGh08qJ9uuTo',
        text:
          'I had an excellent experience with Mohsin - he was perfectly clear about the process, answered every question I had and made the process seamless! Thank you Mohsin and the UDC Team'
      },
      {
        name: 'S Caskey',
        rating: 5,
        timeAgo: '2 weeks ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/sJAkysyO2nvnKDxV6',
        text:
          'Super easy to deal with hassle free finace and a amazing team'
      },
      {
        name: 'J Scott',
        rating: 5,
        timeAgo: '3 weeks ago',
        platformLogo: '/google-logo.svg',
        url: 'https://share.google/9FVhra0OFvYs36GrX',
        text:
          'Very easy and seamless. Will use the UDC team again'
      }
    ]
  }

  const backgroundColor = mockData.styles.backgroundColor

  return (
    <section
      className='_block-section _testimonial-section py-16 px-4 sm:px-6 lg:px-8'
      id={mockData.anchorTarget || undefined}
      style={{ backgroundColor }}
    >
      <header className='max-w-2xl mx-auto text-center pb-6'>
        {/* Using mock header copy until BE wiring is ready */}
        <h2 className='text-3xl md:text-4xl font-extrabold tracking-tight text-balance mb-2'>
          {mockData.title}
        </h2>
        <div className='_simple-rte sm:px-6 mt-6'>
          <p>{mockData.description}</p>
        </div>
        <div className='flex items-center justify-center mt-5'>
          <Button href={mockData.ctaUrl} target='_blank' rel='noopener noreferrer' variant='secondary' size='sm'>{mockData.ctaText}</Button>
        </div>
      </header>
      <div className='mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8'>

        <Swiper
          grabCursor
          spaceBetween={20}
          slidesPerView='1'
          data-style='carousel'
          data-swiper='testimonialsCarousel'
          loop
          modules={[Navigation]}
          className='w-full overflow-visible'
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }}
          breakpoints={{
            640: {
              slidesPerView: 1
            },
            768: {
              slidesPerView: 2
            },
            1200: {
              slidesPerView: 3
            }
          }}
        >

          {mockData.reviews.map((review, index) => (
            <SwiperSlide key={index} className='!flex flex-col !h-auto'>
              <a href={review.url} target='_blank' rel='noopener noreferrer' className='w-full flex flex-col h-full bg-[--testimonial-bg] p-6 rounded-xl group'>
                <div className='flex items-start justify-between gap-5'>
                  <span className='size-[60px] text-3xl font-extrabold rounded-full flex items-center justify-center leading-[1] text-default-50 bg-default-500 shrink-0'>
                    {review.name.charAt(0)}
                  </span>
                  <div className='grow flex flex-col gap-1.5'>
                    <h3 className='text-xl font-extrabold'>{review.name}</h3>
                    <div className='flex items-center gap-1.5 text-[--testimonial-star-bg]'>
                      {Array.from({ length: 5 }).map((_, i) => (
                        <StarIcon key={i} className={`shrink-0 ${i < review.rating ? '' : 'opacity-30'}`} />
                      ))}
                    </div>
                    <span className='text-base font-semibold text-default-500'>{review.timeAgo}</span>
                  </div>
                  <div className='relative size-8 shrink-0 mr-4'>
                    <img className='absolute inset-0 w-full h-full object-cover' src={review.platformLogo} alt='Google logo' />
                  </div>
                </div>
                <p className='my-4 text-lg line-clamp-3 font-semibold max-w-[520px]'>
                  {review.text}
                </p>
                <div className='flex grow flex-col justify-end'>
                  <span className='text-base font-semibold text-default-500 group-hover:underline'>Read more</span>
                </div>
              </a>
            </SwiperSlide>
          ))}
          <div className='w-24 mx-auto flex items-center justify-center gap-4 pt-12'>
            <button
              className='swiper-button-prev cursor-pointer text-default-300 border border-default-300 px-5 py-[7px] rounded-full transition-all pointer-events-auto shadow-sm hover:bg-default-100 hover:text-default-900 hover:border-default-600 duration-300'
            >
              <ArrowRight className='transform rotate-180' />
              <span className='sr-only'>Previous</span>
            </button>
            <button
              className='swiper-button-next cursor-pointer text-default-300 border border-default-300 px-5 py-[7px] rounded-full transition-all pointer-events-auto shadow-sm hover:bg-default-100 hover:text-default-900 hover:border-default-600 duration-300'
            >
              <ArrowRight />
              <span className='sr-only'>Next</span>
            </button>
          </div>
        </Swiper>
      </div>
    </section>
  )
}

reactMount('testimonialsBlock', testimonialsBlock)
